import { render, staticRenderFns } from "./CookiesAgreementComponent.vue?vue&type=template&id=38f563c6&scoped=true"
import script from "./CookiesAgreementComponent.vue?vue&type=script&lang=js"
export * from "./CookiesAgreementComponent.vue?vue&type=script&lang=js"
import style0 from "./CookiesAgreementComponent.vue?vue&type=style&index=0&id=38f563c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f563c6",
  null
  
)

export default component.exports